export enum MarketingCharacteristics {
  DISPLAY_ORDER = 'DISPLAY_ORDER',
  OFFER_NAME = 'OFFER_NAME',
  OFFER_DESCRIPTION = 'OFFER_DESCRIPTION',
  UI_TYPE = 'UI_TYPE',
  DISCLOSURE = 'DISCLOSURE',
  EXPLICIT_CONSENT_REQUIRED = 'EXPLICIT_CONSENT_REQUIRED',
  TAG = 'TAG',
}
